import { Component, Vue } from 'vue-property-decorator';
import TextField from '@/components/TextField.vue';

@Component({
  components: {
    TextField,
  },
})
export default class ChoiceElementMixin extends Vue {
  $refs!: Vue['$refs'] & {
    textField: TextField;
  };

  refName = 'textField';

  setFocus(currentValue: boolean) {
    this.$nextTick(() => {
      if (currentValue) {
        this.$refs.textField.$el.querySelector('input')!.focus();
      }
    });
  }
}
